export const delayPromise = async (ms: number): Promise<any> => {
	if (!ms) {
		return Promise.resolve();
	}

	return new Promise(resolve => setTimeout(resolve, ms));
};
